// extracted by mini-css-extract-plugin
export var tcbLeft = "twoColumnBlock-module--tcbLeft--30405";
export var tcbRight = "twoColumnBlock-module--tcbRight--28b38";
export var tcbWrapper = "twoColumnBlock-module--tcbWrapper--b7a8f";